import React, { useEffect, useState } from "react";
import "./App.css";
import logo from "./assets/logo.jpeg";
import image1 from "./assets/Image1.jpeg";
import EmailModal from "./components/EmailModal";
import "swiper/css";
import "swiper/css/navigation";
import Review from "./components/ReviewCard";
import Offercard from "./components/Offercard";
import ReviewModal from "./components/ReviewModal";
import { BaseUrl } from "./config";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import {
  OfferRundUmsHaus,
  OfferRundImHaus,
  OfferServices,
  OfferRundUmDenGarten,
  OfferHüpfburgVerleih,
} from "./assets/Offertexts";

function App() {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [initialOption, setInitialOption] = useState(-1);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [reviews, setReviews] = useState([]);

  function email(option) {
    setInitialOption(option);
  }

  useEffect(() => {
    if (initialOption >= 0) setIsEmailModalOpen(true);
  }, [initialOption]);

  const fetchReviews = async () => {
    const res = await fetch(`${BaseUrl}/api/review`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!res.ok) console.log("Could not fetch Reviews form Server");

    const data = await res.json();
    console.log(data);
    setReviews(data.reviews);
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  function useWindowSize() {
    const [size, setSize] = useState([window.innerWidth, window.innerHeight]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerWidth, window.innerHeight]);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
    return size;
  }
  const [width, height] = useWindowSize();
  return (
    <div className="App">
      <EmailModal
        option={initialOption}
        isOpen={isEmailModalOpen}
        onClose={() => {
          setIsEmailModalOpen(false);
        }}
      />
      <ReviewModal
        option={initialOption}
        isOpen={isReviewModalOpen}
        onClose={() => {
          setIsReviewModalOpen(false);
        }}
      />

      <header className="App-header">
        <h1>Rundum Krebs - Ihr Hausmeisterservice</h1>
      </header>

      <div className="Hero">
        <div className={width > 480 ? "Row" : "Column"}>
          <div className="Column">
            <h3>
              Tobias Krebs - Ihr freiberuflicher Hausmeisterservice in
              Brandenburg an der Havel
            </h3>
            <div className="Separator" />
            <br />
            <p className="Text">
              Herzlich willkommen bei Rundum Krebs, Mein Name ist Tobias Krebs,
              ich bin 34 Jahre alt und lebe in Brandenburg an der Havel. Mit
              meiner sorgfältigen Arbeitsweise und einer transparenten Beratung,
              bin ich Ihr zuverlässiger Partner - rundum Ihr Haus, Ihrer Wohnung
              und Ihrem Garten. Zögern Sie nicht und sprechen Sie mich direkt
              an, sicher finde ich eine Lösung für Ihr Anliegen. Gern können Sie
              mich telefonisch sowie per E-Mail kontaktieren.
            </p>
            <button
              style={{ width: "100%" }}
              className="Button"
              onClick={() => {
                email(-1);
                setIsEmailModalOpen(true);
              }}
            >
              Anfragen
            </button>
            {/* 
            <div className="w-full max-w-full" style={{ marginTop: "10px" }}>
              <Swiper
                modules={[Navigation]}
                spaceBetween={20}
                slidesPerView={1}
                navigation
                className="my-8"
              >
                {images.map((src, index) => (
                  <SwiperSlide key={index}>
                    <div style={{ padding: "1 rem" }}>
                      <img
                        src={src}
                        alt={`Bild ${index + 1}`}
                        className="w-full h-auto rounded shadow"
                        width={"100%"}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          */}
          </div>

          <div className="Column">
            <div>
              <img src={logo} alt="My Image" height={800} />
            </div>
          </div>
        </div>
        <div className="Row">
          <div className="Column">
            <h3>Leistungen</h3>
            <div className="Separator" />
            <br />
            <div className="serviceRow">
              <Offercard Offer={OfferRundUmsHaus} />
              <Offercard Offer={OfferRundImHaus} />
              <Offercard Offer={OfferServices} />
              <Offercard Offer={OfferRundUmDenGarten} />
              <Offercard Offer={OfferHüpfburgVerleih} />
            </div>
          </div>
        </div>

        <div className="Row">
          <div className="Column">
            <div className="Separator" />
            <h3>Das sagen Kunden</h3>
            <button
              className="RezensionButton"
              onClick={() => {
                setIsReviewModalOpen(true);
              }}
            >
              Rezension schreiben
            </button>

            <div className="reviews-container">
              <AliceCarousel
                mouseTracking
                infinite
                disableButtonsControls
                responsive={{
                  0: { items: 1 }, // Smartphones → 1 Karte
                  500: { items: 2 }, // Tablets → 2 Karten
                  1000: { items: 3 }, // Desktop → 3 Karten
                }}
                items={reviews.map((review, i) => (
                  <Review review={review} />
                ))}
              />
            </div>
          </div>
        </div>
      </div>
      <footer className="App-Footer">
        <div className="footer-column">
          Impressum:
          <p>
            Tobias Krebs
            <br />
            Jahnstraße 4D
            <br />
            14776 Brandenburg an der Havel
            <br />
            St. Nr. 048/241/08515
            <br />
          </p>
        </div>
        <div className="footer-column">
          Kontakt:
          <p>
            Tel.: 015755651647
            <br />
            E-Mail: rundumkrebs@gmail.com
            <br />
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
